<template>
  <div class="animated fadeIn">
    <h4 class="page-title">Electric Vehicles Notification Settings</h4>
    <hr>
    <b-table
      v-if="items.length"
      :items="items"
      :fields="fields"
      responsive
      striped>
      <template v-slot:cell(batteryLevel)="{ item }">
        {{ item.batteryLevel }}%
      </template>
      <template v-slot:cell(batteryLevelThreshold)="{ index, item }">
        <div class="d-flex" style="min-width: 150px">
          <b-input-group
            size="sm"
            append="%"
            class="mr-3">
            <b-form-input
              v-model="items[index].batteryLevelThreshold"
              type="number"
              size="sm" />
          </b-input-group>
          <b-btn
            variant="success"
            size="sm"
            @click="updateThreshold({ itemId: item.itemId, batteryLevelThreshold: item.batteryLevelThreshold })">
            Update
          </b-btn>
        </div>
      </template>
    </b-table>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { toastr } from '@/services'

export default {
  name: 'ElectricVehicles',
  data () {
    return {
      items: [],
      fields: [
        'licensePlate',
        'name',
        'batteryLevel',
        'batteryLevelThreshold'
      ]
    }
  },
  computed: {
    ...mapState('mrs', ['electricVehicles'])
  },
  created () {
    this.getElectricVehicles()
  },
  methods: {
    getElectricVehicles () {
      this.$store.dispatch('mrs/getElectricVehicles').then((data) => {
        this.items = data
      })
    },
    updateThreshold (data) {
      this.$store.dispatch('mrs/updateEvThreshold', data).then(() => {
        this.getElectricVehicles()
        toastr.success(false, 2000)
      })
      .catch((err) => {
        const msg = err.data && err.data.msgContent ? err.data.msgContent.errorMessage : err.message
        toastr.error(msg)
      })
    }
  }
}
</script>